<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">如何发送公众号模板消息?</div>
      <div class="panel-body">
        <span
          class="span1"
        >很多人都知道微信公众号除了固定的群发次数外，微信服务号还能够通过模板消息功能来打破这个限制，但是却不知道微信公众号开通了模板消息后如何推送，因为在公众号后台找个了遍都没找到推送功能，那么开通了模板消息后，到底该怎么使用呢？其实，模板消息只是公众号自带的一个功能，其本身并没有推送送能，需要通过鱼塘软件等第三方软件来推送模板消息的，今天小鱼儿就来告诉你如何利用鱼塘软件快速的推送模板消息。</span>
        <p class="p1">一、首先，你需要以下物料:</p>
        <p class="span1">
          1、认证的服务号;
          <br />2、汇客软件模板消息功能。
        </p>
        <p class="p1">二、文字描述具体操作：</p>
        <p class="span1">
          1、服务号在公众号后台开通模板消息，并添加相关模板(所有服务号都可以在功能->添加功能插件处看到申请模板消息功能的入口，但只有认证后的服务号才可以申请模板消息的使用权限并获得该权限)，
          <br />2、进入汇客软件营销平台--点击底部的同步管理，选择模板消息，点击同步;
          <br />3、进入汇客软件营销平台，素材管理界面，点击创建模板消息，可以添加常用模板消息。
          <br />4、进入鱼塘微客服系统操作界面，选择模板消息的图标，可以选择刚才步骤3保存的素材，也可以新建模板。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {

};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


